import store from "../store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore"; // esto es para la base de datos
import "firebase/storage"; // esto es para el storage
import router from "../routes";
import apiServices from "@/services/yungol-services";

// siete produccion
const config = {
  apiKey: "AIzaSyCfO27bicj-LIuu1AhC4jbbq1-eps5Xvvg",
  authDomain: "sieteapp-yungol.firebaseapp.com",
  projectId: "sieteapp-yungol",
  storageBucket: "sieteapp-yungol.appspot.com",
  messagingSenderId: "773405419012",
  appId: "1:773405419012:web:e54a3e3d30eaa64c5df751",
};

export default {
  install: (Vue, options) => {
    firebase.initializeApp(config);
    const auth = firebase.auth();
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithEmailAndPassword(username, pass);
      },
      loginGoogle: async () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithPopup(provider);
      },
      logout: async () => {
        await auth.signOut();
        store.commit("restartStore");
      },
      sendPasswordResetEmail: async (email) => {
        await auth.sendPasswordResetEmail(email, {
          url: "https://sietegho.com",
        });
      },
      createuser: (email, password) => {
        return auth.createUserWithEmailAndPassword(email, password);
      },
    };
    Vue.prototype.$fire = {
      getImgCompany: (id) => {
        return firebase
          .storage()
          .ref(`images/companies/img_${id}`)
          .getDownloadURL();
      },
      saveImgCompany: (file, id) => {
        if (file && id) {
          return firebase
            .storage()
            .ref(`images/companies/img_${id}`)
            .put(file);
        }
      },
      deleteImgCompany: (path) => {
        return firebase
          .storage()
          .ref(path)
          .delete();
      },
      getAttached: (process) => {
        return firebase
          .storage()
          .ref(`attached/${process}`)
          .list({ maxResults: 50 });
      },
      saveAttached: (file, process) => {
        if (file && process) {
          return firebase
            .storage()
            .ref(
              `attached/${process}/` + new Date().getTime() + "-" + file.name
            )
            .put(file);
        }
      },
      deleteAttached: (path) => {
        return firebase
          .storage()
          .ref(path)
          .delete();
      },
      deleteFolderAttached: (process) => {
        const folder = firebase.storage().ref(`attached/${process}`);
        folder
          .listAll()
          .then((result) => {
            result.items.forEach((item) => {
              item
                .delete()
                .then(() => {
                  // console.log('Archivo eliminado con éxito.');
                })
                .catch((error) => {
                  console.error("Error al eliminar el archivo:", error);
                });
            });
          })
          .catch((error) => {
            console.error(
              `Error al listar archivos en la carpeta ${process}:`,
              error
            );
            return false;
          });

        return true;
      },
      putimg: (file) => {
        return firebase
          .storage()
          .ref("images/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      reffile: (file) => {
        return firebase
          .storage()
          .ref("files/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      refexcel: (file) => {
        return firebase
          .storage()
          .ref("excel/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      reflideres: (file) => {
        return firebase
          .storage()
          .ref("lideres/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
    };
    auth.onAuthStateChanged((user) => {
      if (user) {
        localStorage.setItem("loggedin", "true");
        store.commit("refreshUser", user);
        store.commit("refreshAuth");
        user.getIdToken().then(
          (idtoken) => {
            store.commit("decodeToken", idtoken);
            if (
              store.state.tokenUser.admin ||
              store.state.tokenUser.cliente ||
              store.state.tokenUser.frs ||
              store.state.tokenUser.lider ||
              store.state.tokenUser.liderl ||
              store.state.tokenUser.ghumana ||
              store.state.tokenUser.free
            ) {
              store.commit("refreshAuth");
              apiServices
                .get(`/empresacredential`, {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                  },
                })
                .then((empresa) => {
                  store.commit("refreshEmpresa", empresa.data);
                });
            } else {
              localStorage.removeItem("loggedin");
              store.commit("restartStore");
              router.replace({
                name: "logout",
              });
            }
          },
          (error) => {
            store.commit("restartStore");
            console.log(error);
          }
        );
      } else {
        localStorage.removeItem("loggedin");
        store.commit("restartStore");
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/firebase/index.js